import styled from 'styled-components';

export const ContainerBannerInformativoAssinatura = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1.5;
  min-width: 0;
`;

export const ContainerInformativoStreaming = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${({ theme }) => theme.spacing[6]}px;
`;

export const ContainerInformacoesAssinatura = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[4]}px;
`;

export const ContainerEscolhaPlanos = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const ContainerPreviewCatalagoStreaming = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing[4]}px;
`;

export const ContainerPlanosAssinaturaTexto = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[4]}px;
`;

export const ContainerPlanos = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  padding-bottom: ${({ theme }) => theme.spacing[5]}px;
  gap: ${({ theme }) => theme.spacing[4]}px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;

  gap: ${({ theme }) => theme.spacing[4]}px;
`;
